import type { SVGProps } from 'react';

interface LoadingSpinnerIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const BAR_COUNT = 8;
const CYCLE_MS = 800;

const SPINNER_BARS = Array.from({ length: BAR_COUNT }, (_, i) => (
  <rect
    key={i}
    x="5.4"
    y="9"
    width="1.2"
    height="3"
    rx="0.6"
    fill="currentColor"
    transform={`rotate(${i * (360 / BAR_COUNT)} 6 6)`}
    className="grain-spinner-bar"
    style={{ animationDelay: `${(i - BAR_COUNT) * (CYCLE_MS / BAR_COUNT)}ms` }}
  />
));

export function LoadingSpinnerIcon({ className, ...props }: LoadingSpinnerIconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {SPINNER_BARS}
    </svg>
  );
}
